import { LoadError, LoadErrorProps } from '../LoadError';

export type StepsLoadErrorProps = Omit<LoadErrorProps, 'subject'>;

export const StepsLoadError = (props: StepsLoadErrorProps) => (
  <LoadError
    subject="the steps of this engagement"
    {...props}
  />
);
